var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 3.99967V5.61301C14.6667 6.66634 14.0001 7.33301 12.9467 7.33301H10.6667V2.67301C10.6667 1.93301 11.2734 1.33301 12.0134 1.33301C12.7401 1.33967 13.4068 1.63301 13.8868 2.11301C14.3668 2.59967 14.6667 3.26634 14.6667 3.99967Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 4.66634V13.9997C1.33325 14.553 1.9599 14.8663 2.3999 14.533L3.53992 13.6797C3.80658 13.4797 4.17992 13.5063 4.41992 13.7463L5.52657 14.8597C5.78657 15.1197 6.21327 15.1197 6.47327 14.8597L7.59326 13.7397C7.8266 13.5063 8.19992 13.4797 8.45992 13.6797L9.59994 14.533C10.0399 14.8597 10.6666 14.5463 10.6666 13.9997V2.66634C10.6666 1.93301 11.2666 1.33301 11.9999 1.33301H4.66659H3.99992C1.99992 1.33301 1.33325 2.52634 1.33325 3.99967V4.66634Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H8",
    stroke: "#A3A3A3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8.66699H7.5",
    stroke: "#A3A3A3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecord);
export default __webpack_public_path__ + "static/media/record.5c12bb5f20331e83726df1243dd44ce9.svg";
export { ForwardRef as ReactComponent };